import React, { useEffect, useState } from "react";
import BreadCrumpBack from "../../../components/navigator/back";
import { user_challenge_opportunity_list } from "../../user/user.api";
import "../careers/tenders.css";

function ChallengesOpportunities(props) {
  const [data, setData] = useState([]);

  const parseDueDate = (value) => {
    if (!value) return null;
    const str = String(value).trim();
    if (!str) return null;

    // Handle known formats explicitly first to avoid browser-dependent parsing
    // (e.g. new Date("01/11/2026") may be treated as mm/dd/yyyy in some browsers)
    const slashParts = str.split("/");
    if (slashParts.length === 3) {
      const [a, b, c] = slashParts;
      // yyyy/mm/dd
      if (a && a.length === 4) {
        const dt = new Date(`${a}-${b}-${c}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
      // dd/mm/yyyy
      if (c && c.length === 4) {
        const dt = new Date(`${c}-${b}-${a}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
    }

    const dashParts = str.split("-");
    if (dashParts.length === 3) {
      const [a, b, c] = dashParts;
      // yyyy-mm-dd
      if (a && a.length === 4) {
        const dt = new Date(`${a}-${b}-${c}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
      // dd-mm-yyyy
      if (c && c.length === 4) {
        const dt = new Date(`${c}-${b}-${a}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
    }

    // Try native parsing next (handles ISO like 2026-04-29T10:20:30Z)
    const native = new Date(str);
    if (!Number.isNaN(native.getTime())) return native;

    return null;
  };

  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);

  const visibleData = data.filter((item) => {
    const due = parseDueDate(item?.due_date);
    if (!due) return true;
    due.setHours(0, 0, 0, 0);
    return due >= todayStart;
  });

  useEffect(() => {
    user_challenge_opportunity_list().then((res) => {
      const rows = Array.isArray(res)
        ? res
        : Array.isArray(res?.data)
        ? res?.data
        : [];

      const mapped = rows
        .filter(
          (x) =>
            String(x?.status).toLowerCase() === "approved" ||
            String(x?.status) === "1"
        )
        .map((item) => ({
          ...item,
          opportunity:
            item?.market_analysis_opportunity?.opportunity ??
            item?.market_analysis_opportunity_name ??
            item?.opportunity ??
            "",
          image: item?.image || "",
          brochure: item?.brochure || "",
        }));

      setData(mapped);
    });
  }, []);

  const handleLink = (linkurl) => {
    if (!linkurl) return;
    const urlLower = String(linkurl).toLowerCase();
    const urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };

  return (
    <div className="tender bg-tender">
      <div>
        <div className="dash-banner ">
          <div className="tix">
            {props.state.language === "ma"
              ? "à´šà´²à´žàµà´šàµà´•à´³àµà´‚ à´…à´µà´¸à´°à´™àµà´™à´³àµà´‚"
              : "Challenges/Opportunities"}
          </div>
        </div>
      </div>

      <BreadCrumpBack />

      <div className="container p-50">
        <div className="bg-white">
          <div className="row tender-box">
            {visibleData.length > 0 ? (
              <>
                {visibleData.map((card, index) => (
                  <div
                    className="bg-tender p-30 " style={{minHeight:"300px"}}
                    key={card?.id ?? card?._id ?? index}
                  >
                    <div className="tender-title mb-2">
                      <p className="head " style={{ overflowWrap: "break-word" }}>
                        <u>{card?.title || "-"}</u>
                      </p>
                    </div>

                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma"
                            ? "à´…à´µà´¸à´°à´‚"
                            : "Opportunity"}
                        </p>
                      </div>
                      <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                        <p>{card?.opportunity || "-"}</p>
                      </div>
                    </div>

                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma"
                            ? "à´¤à´²à´•àµà´•àµ†à´Ÿàµà´Ÿàµ"
                            : "Title"}
                        </p>
                      </div>
                      <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                        <p>{card?.title || "-"}</p>
                      </div>
                    </div>

                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma"
                            ? "à´µà´¿à´µà´°à´£à´‚"
                            : "Description"}
                        </p>
                      </div>
                      <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                        <p>{card?.description || "-"}</p>
                      </div>
                    </div>

                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma"
                            ? "à´…à´µà´¸à´¾à´¨ à´¤àµ€à´¯à´¤à´¿"
                            : "Due Date"}
                        </p>
                      </div>
                      <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                        <p>{card?.due_date || "-"}</p>
                      </div>
                    </div>

                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma"
                            ? "à´²à´¿à´™àµà´•àµ"
                            : "Link"}
                        </p>
                      </div>
                      <div className="col-lg-10 col-md-12 col-sm-12 contentx overf">
                        <p>
                          {card?.site_url ? (
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleLink(card.site_url);
                              }}
                              className="break_link"
                            >
                              {props.state.language === "ma"
                                ? "à´•à´¾à´£àµà´•"
                                : "Open"}
                            </a>
                          ) : (
                            "-"
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma"
                            ? "à´¬àµà´°àµ‹à´·àµ¼"
                            : "Brochure"}
                        </p>
                      </div>
                      <div className="col-lg-10 col-md-12 col-sm-12 contentx overf">
                        <p>
                          {card?.brochure ? (
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                const url = card.brochure;
                                const filename =
                                  url.split("/").pop() || "brochure.pdf";
                                const link = document.createElement("a");
                                link.href = url;
                                link.download = filename;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              }}
                              className="break_link"
                              style={{ cursor: "pointer" }}
                            >
                              {props.state.language === "ma"
                                ? "à´¡àµ—àµºà´²àµ‹à´¡àµ"
                                : "Download"}
                            </a>
                          ) : (
                            "-"
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="tender-datas">
                      <div className="col-lg-2 col-md-12 col-sm-12 label">
                        <p>
                          {props.state.language === "ma"
                            ? "à´šà´¿à´¤àµà´°à´‚"
                            : "Image"}
                        </p>
                      </div>
                      <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                        {card?.image ? (
                          <img
                            src={card.image}
                            alt=""
                            style={{
                              width: "140px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        ) : (
                          <p>-</p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div
                className="d-flex justify-content-center"
                style={{ fontSize: "20px" }}
              >
                No Recent Postings
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChallengesOpportunities;
